import leadStore from '@/store/lead'

import { logInfo } from '@/helpers/Logger'

export default function useContentsquare() {
  // HOOKS

  function triggerCSPageEvent(value) {
    window._uxa = window._uxa || []
    window._uxa.push(['trackPageEvent', value])

    logInfo(['%ctrackPageEvent', 'color: yellow', value])
  }

  function triggerCSPageView() {
    window._uxa = window._uxa || []

    sendCSDynamicVariables()

    const value = window.location.pathname + window.location.hash.replace('#', '?__')

    window._uxa.push(['trackPageview', value])
    logInfo(['%ctrackPageview', 'color: yellow', value])
  }

  function sendCSDynamicVariables() {
    window._uxa.push(['trackDynamicVariable', { key: 'leadCode', value: leadStore.getLeadCode() }])
  }

  return {
    triggerCSPageEvent,
    triggerCSPageView,
  }
}
